<template>
   <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div v-else>
          <!-- Keep-alive should wrap <router-view /> -->
         
    <div class="homepage d-flex flex-column">
           <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary header_new">
            <div class="d-flex align-items-center">
         
               <span @click="goBack()" class="text-white"> <i class="bi bi-arrow-left-circle-fill"></i></span> &nbsp; &nbsp;
                  
                  <span>
                     <h5 class="text-white">{{language?.attendance}}  </h5>
                  </span>
         
           
            </div>
            



         </div>
    
    
         <!-- navbar -->
         <!-- <div class="homepage-navbar  shadow mb-auto p-3 bg-primary header_new">-->
         <!--   <div class="d-flex align-items-center">-->
         
         <!--      <span @click="goBack()" class="text-white"> <i class="bi bi-arrow-left-circle-fill fs-5 text-white"></i></span> &nbsp; &nbsp;-->
                  
         <!--         <span>-->
         <!--            <h4 class="text-white fw-bold7">{{language?.attendance}}</h4>-->
         <!--         </span>-->
         
            
         <!--   </div>-->
            



         <!--</div>-->
            



         </div>
    
         <!-- body -->
         <div class="my-auto overflow-auto vh-100 bg-white">
           
             <table class="table">
                            <thead>
                                <tr>
                                    <td>Sr</td>
                                    <td>Name</td>
                                    <td>Attendance</td>
                                </tr>
                            </thead>
                            <tbody>
 
                        
                      
                                <tr v-for="(item,i) in studnetlist" :key="item.id">

         <td>{{ i+1 }}</td>
        <td>{{ item.student_name }}</td>
        <td>
          <div class="form-check form-switch">
            <input 
              class="form-check-input" 
              type="checkbox" 
              role="switch"
              :id="'toggle-' + item.id" 
              v-model="item.active"
            >
          </div>
        </td>
      </tr>
                            </tbody>
                            
                        </table>
                        
                        
                        <!--<div class="card-body d-flex justify-content-between align-items-center py-3">-->
                        <!--    <div class="d-flex align-items-center">-->
                        <!--        <div class="rounded-circle bg-light d-flex align-items-center justify-content-center me-3" -->
                        <!--             style="width: 40px; height: 40px; background-color: #f0f4ff !important;">-->
                        <!--            <span class="text-primary fw-semibold">{{item.rollno}}</span>-->
                        <!--        </div>-->
                        <!--        <div>-->
                        <!--            <h6 class="fw-bold7 text-dark mb-0 ">{{item.name}}</h6> -->
                        <!--        </div>-->
                        <!--    </div>-->
                        <!--    <div class="form-check form-switch">-->
                        <!--        <input class="form-check-input" type="checkbox" role="switch" -->
                        <!--               :id="'toggle-'+item.id" v-model="item.active" style="width: 40px; height: 20px;">-->
                        <!--    </div>-->
                        <!--</div>-->
                
            <!--    <div class="pt-3 bg_card">-->
            <!--         <label for="mobile" class="form-label">{{language?.entry_date}}</label>-->
            <!--         <input type="date"  id="mobile" v-model="attendance.entrydate" class="form-control w-50" required>-->
               
       
            <!--</div> -->

        <div class="bg-white footer_part p-2 fw-bold7">
            <div class="d-flex mb-5 gap-5">
                <span>Total : {{studnetlist?.length}}</span>
                <span class="text-success">Present : {{present_count}}</span>
                <span class="text-danger">Absent : {{absent_count}}</span>
            </div>
            <button class="btn btn-primary fw-bold7 save-btn mb-1" @click="saveattendance">Confirm And Submit</button>
        </div>





         </div>
         
 
      </div>

      
 
</template>
<style scoped>
.footer_part{
 position: fixed;
    bottom: 0;
    font-size: 16px;
    left: 0;
    width: 100%;
    border-radius: 0;
    border-top: 1px solid black;
    border-radius: 10px 10px 0px 0px;
    background: floralwhite;
}
.save-btn {
  
  width: 100%;
  border-radius: 0; /* optional - button ko square rakhne ke liye */
}
.homepage {
     background: #e5e7ff;
}
thead{
    background: #e5e7ff;
    font-size: medium;
        font-weight: 900;
}

table{
    font-size: medium;
}
tr{
    border-bottom: 1px solid;
    border-bottom-style: dashed !important;
}
.header_new {
    border-radius: 0px 0px 20px 20px;
}
</style>
  
<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  components: { 
  },
  mounted() { 
   //  this.fetchWeather();
    this.examid=this.$route.query.id;
    this.getStudentsList(this.$route.query.id); // Call the method here
    
},
  data() {
    let todayDate = new Date().toISOString().slice(0, 10);
    return { 
      loading:false,
      error:null,
      isUserLogged:false,
      user_details:[],
      language: this.getLocalStorageArray('lang'),
      present_count:0,
      absent_count:0,
      examid:0,
   
      
  

      studnetlist:[], 
      classList:[],
      branch_name:'',


      attendance:{
        // entrydate:todayDate,
     
      
      },
             ids:[],

    }
  },
 computed: {
    present_count() {
      return this.studnetlist.filter(s => s.active).length;
    },
    absent_count() {
      return this.studnetlist.filter(s => !s.active).length;
    }
  },
  methods:{
    initializeHomeContent(){
    

    },
    goBack() {
          
          this.$router.go(-1);
  },
  goprevious() {
          
          this.$router.go("/branch");
  },

 
  
    async getStudentsList(examid) {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getstudentbyclass",{examid:examid}).then((response) => {
        
                  self.studnetlist = response.data.studnetlist.map(s => ({
                      ...s,
                      active: true   
                  }));
                  
                  self.present_count=self.studnetlist.length;
                  self.absent_count=0;
              self.language=response.data.language;
        
          }).then(() => {
                 
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 





       saveattendance() {
       
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;


                const selectedStudents = this.studnetlist 
                    .map(student => ({
                      id: student.id,
                      name: student.name,
                      examid: student.examid,
                      active: student.active
                    }));

      
            axios.post("saveattendance", {
                students: selectedStudents,   
                examid: self.attendance.examid,
                entrydate: self.attendance.entrydate
              }).then((response) => {
 
                  self.$router.push('/AttendanceReport?id='+self.examid);
 
        
          }).then(() => {
                
          }).catch((err) => {
            
          });;
         
  
        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 


      editStudent(editStudent) {
         window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
         this.addstudent=editStudent;
      }, 



 

        getLocalStorageArray(key) {
                let data = localStorage?.getItem(key);
                try {
                    return data ? JSON.parse(data) : [];
                } catch (e) {
                    console.error("Error parsing localStorage data", e);
                    return [];
                }
            },






              async getstudent(id) {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getstudentlist",{id:id}).then((response) => {
               self.studnetlist=response.data.studnetlist;
                self.classList=response.data.classList;
               self.language=response.data.language;
               localStorage.setItem('lang',response.data.language);
        
          }).then(() => { 


          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 




















  }
}






</script>
